import { Logger } from '@sitecore-search/common';
const subscribers = [];
const actionHandlers = [];
// action actionHandlers are subscribers that handle actions after all subscribers have been notified
export default class Dispatcher {
    static addActionHandler(listener) {
        subscribers.push(listener);
    }
    static removeActionHandler(listener) {
        const index = actionHandlers.indexOf(listener);
        if (index !== -1) {
            actionHandlers.splice(index, 1);
        }
    }
    static subscribe(listener) {
        subscribers.push(listener);
    }
    static unsubscribe(listener) {
        const index = subscribers.indexOf(listener);
        if (index !== -1) {
            subscribers.splice(index, 1);
        }
    }
    static dispatch(action) {
        Logger.debug('dispatcher ::: dispatch', `[${action.type}]`, action.payload);
        subscribers.forEach((subscriber) => {
            subscriber.handleAction(action);
        });
        actionHandlers.forEach((handler) => {
            handler.handleAction(action);
        });
    }
}
